import script from "./EmailActionHandler.vue?vue&type=script&lang=ts"
export * from "./EmailActionHandler.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__